import script from "./StarRating.vue?vue&type=script&setup=true&lang=js"
export * from "./StarRating.vue?vue&type=script&setup=true&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=5f393bae&scoped=true&lang=css"

import exportComponent from "E:\\TestProject Temurako\\e-commerce-app-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f393bae"]])

export default __exports__